import { AnySchema } from 'ajv';

import { FieldErrorMessage } from '../../../../models/FieldErrorMessage';
import { contractFormSchema } from '../../../../styledComponents/Forms/SelectContractForm/selectContractForm.validation';
import { subscriptionOptionsSchema } from '../../../../styledComponents/Forms/SubscriptionOptions/subscriptionOptions.validation';
import { subscriptionSummarySchema } from '../../../../styledComponents/FormSummary/SubscriptionSummary/subscriptionSummary.validation';
import { validateFormData } from '../../../../utils/validations/validateFormData';
import { subscriptionPricingSchema } from '../../../../styledComponents/RenewSubscriptionFormPage/FormSections/Common/SubscriptionRenewPricing/subscriptionPricing.validation';
import { keRenewSubscriptionDetailsSchema } from '../../../../styledComponents/RenewSubscriptionFormPage/FormSections/KidnapAndExtortionRenewSubscription/KERenewSubscriptionDetails/keRenewSubscriptionDetails.validation';
import { IEditKEOrganizationSubscriptionModel } from '../../../../models/interfaces/Subscription/KidnapAndExtortion/EditKEOrganizationSubscriptionModel';

const schema: AnySchema | any = {
  type: 'object',
  properties: {
    ...keRenewSubscriptionDetailsSchema.properties,
    ...subscriptionOptionsSchema.properties,
    ...subscriptionSummarySchema.properties,
    ...subscriptionPricingSchema.properties,
  },
  dependencies: {
    ...subscriptionOptionsSchema.dependencies,
    ...subscriptionSummarySchema.dependencies,
  },
  required: [
    ...contractFormSchema.required,
    ...keRenewSubscriptionDetailsSchema.required,
    ...subscriptionOptionsSchema.required,
    ...subscriptionSummarySchema.required,
    ...subscriptionPricingSchema.required,
  ],
};

export const validateKEEditRenewSubscriptionForm = (
  data: IEditKEOrganizationSubscriptionModel,
  additionalErrors?: FieldErrorMessage[],
) => validateFormData(data, additionalErrors, schema);
